import React from 'react'

class NavVersetzungsplan extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M5.5 1.5v2h11v-2h-11zM4 0h14v5H4V0zm7 11h7.5V9H11v2zM9.5 7.5H20v5H9.5v-5zm-5 9v2h9v-2h-9zM3 15h12v5H3v-5zM1.5 9v2h4V9h-4zM0 7.5h7v5H0v-5z"
        />
      </svg>
    )
  }
}

export default NavVersetzungsplan
